<template>
  <div class="app-container">
    <el-page-header @back="goBack" content="楼宇列表"> </el-page-header>
    <el-tabs
      class="tab-v"
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
    >
      <el-tab-pane label="楼宇信息" name="space"></el-tab-pane>
      <template v-if="roles.includes('/space/house_lists')">
        <el-tab-pane
          :key="index"
          v-for="(item, index) in houseFloorList"
          :label="item.floor + '楼'"
          :name="item.id.toString()"
        ></el-tab-pane>
      </template>
    </el-tabs>
    <div v-if="activeName == 'space'" class="spaceDetail">
      <el-form
        :model="spaceInfo"
        ref="spaceInfo"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            disabled
            v-model="spaceInfo.park_id"
            placeholder="请选择园区"
            @change="formPark"
            class="w400"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="楼宇名称" prop="name">
          <el-input
            v-model="spaceInfo.name"
            disabled
            placeholder="请输入楼宇名称"
            class="w400"
          ></el-input>
        </el-form-item>
        <el-form-item label="建筑面积" prop="total_meters">
          <el-input
            v-model="spaceInfo.total_meters"
            disabled
            placeholder="请输入建筑面积"
            class="w400"
          >
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="楼层数" prop="floor">
          <el-input
            disabled
            v-model="spaceInfo.floor"
            placeholder="请输入楼层数"
            class="w400"
          ></el-input>
        </el-form-item>
        <el-form-item label="出租率" prop="total_meters">
          <el-input
            v-model="spaceInfo.hire_rate"
            disabled
            placeholder="请输入建筑面积"
            class="w400"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="楼宇类型" prop="house_type_ids">
          <el-select
            filterable
            v-model="spaceInfo.house_type_ids"
            placeholder="请选择楼宇类型"
            class="w400"
            multiple
            disabled
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in spaceHouseList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="spaceInfo.remark"
            class="w400"
            disabled
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div v-else class="house">
      <el-button
        :disabled="multipleSelection.length == 0"
        type="danger"
        @click="batchDel()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/space/house_del')"
        >批量删除</el-button
      >
      <el-button
        type="primary"
        @click="addHouse()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/space/house_add')"
        >添加房源</el-button
      >
      <el-table
        max-height="700"  v-loading="listLoading" 
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        :data="houseList"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        row-key="id"
        :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page - 1) * page_size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <!-- <el-table-column label="房源名称" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column> -->
        <el-table-column label="房间号" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.house_number }}
          </template>
        </el-table-column>
        <el-table-column label="价格（元/㎡）" align="center">
          <template slot-scope="scope">
            {{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column label="租赁面积（㎡）" align="center">
          <template slot-scope="scope">
            {{ scope.row.meters }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="关联企业" align="center" min-width="180">
        <template slot-scope="scope"> {{ scope.row.hire_rate }}% </template>
      </el-table-column> -->
        <el-table-column label="楼宇类型" align="center">
          <template slot-scope="scope">
            {{ scope.row.house_type.title }}
          </template>
        </el-table-column>
        <el-table-column label="房源性质" align="center" min-width="120">
          <template slot-scope="scope">
            {{
              scope.row.use_type == 1
                ? "设备用房"
                : scope.row.use_type == 2
                ? "设施用房"
                : "出租用房"
            }}</template
          >
        </el-table-column>
        <el-table-column label="使用状态" align="center" min-width="120">
          <template slot-scope="scope">
            {{
              scope.row.house_status == 1
                ? "空闲中"
                : scope.row.house_status == 2
                ? "已出租"
                : scope.row.house_status == 3
                ? "已预定"
                : "--"
            }}</template
          >
        </el-table-column>
        <el-table-column label="房屋状态" align="center" min-width="120">
          <template slot-scope="scope">
            {{
              scope.row.status == 1
                ? "启用"
                : scope.row.status == 2
                ? "禁用"
                : "--"
            }}</template
          >
        </el-table-column>
        <el-table-column label="房屋关联" align="center" min-width="180">
          <template slot-scope="scope"> {{ scope.row.rel_name }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="220"
          fixed="right"
        >
          <template slot-scope="scope">
            <!-- <el-button
            size="mini"
            type="success"
            @click="edit(scope.row)"
            v-if="roles.includes('/space/edit')"
            >编辑</el-button
          > -->
            <el-button
              size="mini"
              type="success"
              @click="seeHouse(scope.row.id)"
              v-if="roles.includes('/space/house_info')"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="info"
              @click="del(scope.row)"
              v-if="roles.includes('/space/house_del')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[15, 30, 50]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 10px"
      >
      </el-pagination>
      <el-dialog
        @opened="openDrawer"
        :close-on-click-modal="false"
        :title="spaceTitle"
        :visible.sync="houseVisible"
        width="600px"
      >
        <el-form
          :model="houseForm"
          :rules="houseRules"
          ref="houseForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="所属园区" prop="park_id">
            <el-select
              filterable
              disabled
              v-model="houseForm.park_id"
              placeholder="请选择园区"
              @change="formPark"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in parkList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="房间名称" prop="name">
            <el-input
              v-model="houseForm.name"
              :disabled="houseType == 'see'"
              placeholder="请输入房间名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="门牌号" prop="house_number">
            <el-input
              :disabled="houseType == 'see'"
              v-model.number="houseForm.house_number"
              placeholder="请输入门牌号"
              οninput="value=value.replace(/[^0-9]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="房间面积" prop="meters">
            <el-input
              class="numInput"
              v-model="houseForm.meters"
              type="Number"
              :disabled="houseType == 'see'"
              placeholder="请输入房间面积"
            >
              <template slot="append">m²</template>
            </el-input>
          </el-form-item>
          <el-form-item label="价格（m²）" prop="price">
            <el-input
              class="numInput"
              v-model="houseForm.price"
              type="Number"
              :disabled="houseType == 'see'"
              placeholder="请输入价格（m²）"
            >
              <!-- <template slot="append">元</template> -->
            </el-input>
          </el-form-item>

          <el-form-item label="楼宇类型" prop="house_type_id">
            <el-select
              filterable
              :disabled="houseType == 'see'"
              v-model="houseForm.house_type_id"
              placeholder="请选择楼宇类型"
            >
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) in spaceHouseList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用房性质" prop="use_type">
            <el-select
              filterable
              :disabled="houseType == 'see'"
              v-model="houseForm.use_type"
              placeholder="请选择用房性质"
            >
              <el-option label="设备用房" :value="1"></el-option>
              <el-option label="设施用房" :value="2"></el-option>
              <el-option label="出租用房" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出租状态" prop="house_status">
            <el-select
              filterable
              :disabled="houseType == 'see'"
              v-model="houseForm.house_status"
              placeholder="请选择出租状态"
            >
              <el-option label="空闲中" :value="1"></el-option>
              <el-option label="已出租" :value="2"></el-option>
              <el-option label="已预定" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="房屋状态" prop="status">
            <el-select
              filterable
              :disabled="houseType == 'see'"
              v-model="houseForm.status"
              placeholder="请选择房屋状态"
            >
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              v-model="houseForm.remark"
              :disabled="houseType == 'see'"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="houseVisible = false">取 消</el-button>
          <el-button
            v-if="houseType == 'add'"
            type="primary"
            @click="append('houseForm')"
            >确 定</el-button
          >
          <el-button
            v-if="houseType == 'see' && roles.includes('/space/house_edit')"
            type="primary"
            @click="edit('houseForm')"
            >编 辑</el-button
          >
          <el-button v-if="houseType == 'edit'" type="primary" @click="redact"
            >确 定</el-button
          >
        </span>
        <!-- </el-form> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pinyin } from "pinyin-pro";
import { infoAgo, openPark, transfer } from "@/api/index";

import {
  spaceExport,
  getSpaceList,
  addSpace,
  house_lists,
  seeSpace,
  openHouseTypeLists,
  addHouse,
  editHouse,
  seeHouse,
  delHouse,
} from "@/api/space";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  data() {
    var home = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/;
      if (!reg.test(value)) {
        callback(new Error("只能输入英文或数字"));
      } else {
      }
    };
    return {
      listLoading: false,
      activeName: "space",
      spaceId: "",
      spaceInfo: {},
      houseType: [],
      parkList: [],
      houseList: [],
      total: 0,
      page: 1,
      page_size: 15,
      houseSearch: {
        is_page: 1,
        name: "",
        park_id: "",
        space_id: "",
        space_floor_id: "",
        house_status: "",
        status: "",
        use_type: "",
        house_type_id: "",
      },
      houseVisible: false,
      houseForm: {},
      houseRules: {
        // name: [
        //   {
        //     required: true,
        //     message: "请输入房间名称",
        //     trigger: "blur",
        //   },
        // ],
        park_id: [
          {
            required: true,
            message: "请选择所属园区",
          },
        ],
        meters: [
          {
            required: true,
            message: "请输入房间面积",
          },
        ],
        house_type_id: [
          {
            required: true,
            message: "请选择用房性质",
          },
        ],
        use_type: [
          {
            required: true,
            message: "请选择用房性质",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
          },
        ],
        house_number: [
          {
            required: true,
            message: "请输入门牌号，英文或数字",
            // validator: home,
          },
        ],
        status: [
          {
            required: true,
            message: "请选择房屋状态",
          },
        ],
        house_status: [
          {
            required: true,
            message: "请选择出租状态",
          },
        ],
      },
      houseType: "",
      spaceTitle: "",
      spaceHouseList: [],
      multipleSelection: [],
      houseFloorList: [],
    };
  },
  created() {
    this.spaceId = this.$route.query.spaceId;
    this.getInfo();
  },
  mounted() {
    this.getPark();
  },
  methods: {
    // 批量删除
    batchDel() {
      var that = this;
      let ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$confirm("确认删除？")
        .then((_) => {
          delHouse({ id: ids.join() }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getHouse();
          });
        })
        .catch((_) => {});
    },
    // 删除
    del(val) {
      var that = this;
      const data = {
        id: val.id,
      };
      this.$confirm("确认删除？")
        .then((_) => {
          delHouse(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }

            that.getHouse();
          });
        })
        .catch((_) => {});
    },
    // 提交编辑
    redact() {
      this.$refs.houseForm.validate((valid) => {
        if (valid) {
          editHouse(this.houseForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getHouse();
              this.houseVisible = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 切换编辑
    edit() {
      this.spaceTitle = "编辑房间";
      this.houseType = "edit";
    },
    // 打开查看
    seeHouse(id) {
      this.spaceTitle = "查看房间";
      this.houseType = "see";
      seeHouse({ id: id }).then((res) => {
        this.houseForm = {
          id: res.data.info.id,
          name: res.data.info.name,
          house_number: res.data.info.house_number,
          space_id: res.data.info.space_id,
          space_floor_id: res.data.info.space_floor_id,
          meters: res.data.info.meters,
          park_id: res.data.info.park_id,
          house_type_id: res.data.info.house_type_id,
          use_type: res.data.info.use_type,
          remark: res.data.info.remark,
          price: res.data.info.price,
          status: res.data.info.status,
          house_status: res.data.info.house_status,
        };
      });
      this.houseVisible = true;
    },
    // 确定添加
    append(formName) {
      var that = this;
      this.$refs.houseForm.validate((valid) => {
        if (valid) {
          if (!this.houseForm.name) {
            this.houseForm.name = this.houseForm.house_number;
          }
          addHouse(this.houseForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.getHouse();
              this.houseVisible = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });
          return false;
        }
      });
    },
    // 打开添加房间弹窗
    addHouse() {
      this.spaceTitle = "添加房间";
      this.houseType = "add";
      this.houseForm = {
        // name: "",
        house_number: "",
        space_id: "",
        space_floor_id: "",
        meters: "",
        park_id: "",
        house_type_id: "",
        use_type: "",
        remark: "",
        price: "",
        status: "",
        house_status: "",
      };
      this.houseForm.space_id = this.spaceId;
      this.houseForm.space_floor_id = this.houseSearch.space_floor_id;
      this.houseForm.park_id = this.houseSearch.park_id;

      this.houseVisible = true;
    },
    // 弹窗打开
    openDrawer() {
      this.$refs.houseForm.clearValidate();
    },
    // 分页切换
    handleSizeChange(val) {
      this.page_size = val;
      this.page = 1;
    },
    handleCurrentChange(val) {
      this.page = val;
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 标签切换
    handleClick(tab, event) {
      this.houseSearch.space_floor_id = tab.name;
      if (tab.name != "space") {
        this.getHouse();
      }
    },
    // 返回
    goBack() {
      this.$router.push("/space/index");
    },
    // 获取楼宇信息
    getInfo(id) {
      var that = this;
      this.spaceHouseList = [];
      seeSpace({ id: this.spaceId }).then((res) => {
        this.spaceInfo = {
          id: res.data.info.id,
          name: res.data.info.name,
          park_id: res.data.info.park_id,
          total_meters: res.data.info.total_meters,
          floor: res.data.info.floor,
          house_type_ids: [],
          remark: res.data.info.remark,
          hire_rate: res.data.info.hire_rate,
        };
        this.houseSearch.park_id = res.data.info.park_id;
        this.houseSearch.space_id = res.data.info.id;
        // this.spaceHouseList =   res.data.info.house_type_lists
        res.data.info.house_type_lists.forEach((element) => {
          // this.spaceHouseList.push(element);
          this.spaceInfo.house_type_ids.push(element.house_type_id);
        });
        this.houseFloorList = res.data.info.house_floor_lists;
        this.formPark(res.data.info.park_id);
        // this.domains = res.data.company_role_data
      });
    },
    // 获取房屋类型
    formPark(e) {
      let data = {
        park_id: e,
        status: 1,
      };
      openHouseTypeLists(data).then((res) => {
        this.spaceHouseList = res.data.lists.data;
      });
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1, index: 4 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取房间列表
    getHouse() {
      let data = this.houseSearch;
      data.page = this.page;
      data.page_size = this.page_size;

      house_lists(data).then((res) => {
        this.total = res.data.lists.total;
        this.houseList = res.data.lists.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.w400 {
  width: 400px;
}
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.searchs {
  ::v-deep .el-form-item__label {
    opacity: 0 !important;
    display: block;
  }
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}

.tab-v {
  margin-top: 20px;
}

::v-deep .el-tabs__item.is-active {
  color: #fff;
  background: #409eff;
}
::v-deep .el-tabs__nav-next,
::v-deep .el-tabs__nav-prev {
  font-size: 20px;
}
.spaceDetail {
  padding: 40px;
  ::v-deep .el-input.is-disabled .el-input__inner {
    color: #606266;
  }
  ::v-deep .el-tag.el-tag--info {
    color: #606266;
    border-color: #606266;
  }
  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    color: #606266;
  }
}
.house {
  padding-top: 20px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
